import { SelectQueryBuilder, sql } from 'kysely'
import { Database } from '../database'
import { LicenceStatus } from '@/client'

export type AccountFilters = {
  ids?: string[]
  tags?: string[]
  createdBefore?: string
  createdAfter?: string
  updatedBefore?: string
  updatedAfter?: string
  deletedBefore?: string
  deletedAfter?: string
  applicationId?: string
  status?: LicenceStatus[]
  isDeleted?: boolean
  isGuest?: boolean
  email?: string
  search?: string
  subAccountId?: string
  accountId?: string
  softwareLicenses?: string[] // JSON string representing a Record<string, SoftwareLicenseMini_Output>
  applications?: string[]
}

export function applyAccountFilters<T>(
  query: SelectQueryBuilder<Database, 'licence_out', T>,
  filters: AccountFilters
): SelectQueryBuilder<Database, 'licence_out', T> {
  if (filters.ids?.length) {
    query = query.where('_id', 'in', filters.ids)
  }
  if (filters.tags?.length) {
    query = query.where('tags', '@>', JSON.stringify(filters.tags))
  }
  if (filters.createdBefore) {
    query = query.where('created', '<', filters.createdBefore)
  }
  if (filters.createdAfter) {
    query = query.where('created', '>', filters.createdAfter)
  }
  if (filters.updatedBefore) {
    query = query.where('updated', '<', filters.updatedBefore)
  }
  if (filters.updatedAfter) {
    query = query.where('updated', '>', filters.updatedAfter)
  }
  if (filters.deletedBefore) {
    query = query.where('deleted_at', '<', filters.deletedBefore)
  }
  if (filters.deletedAfter) {
    query = query.where('deleted_at', '>', filters.deletedAfter)
  }
  if (filters.applicationId) {
    query = query.where('software_id', '=', filters.applicationId)
  }
  if (filters.subAccountId) {
    query = query.where('sub_account_id', '=', filters.subAccountId)
  }
  if (filters.status?.length) {
    query = query.where('status', 'in', filters.status) // Check if status matches any value in the array
  }
  if (filters.isDeleted !== true) {
    query = query.where('deleted', '=', filters.isDeleted ? 1 : 0)
  }
  if (filters.search) {
    query = query.where((eb) =>
      eb.or([
        eb('name', 'like', `%${filters.search}%`),
        eb('email', 'like', `%${filters.search}%`),
      ])
    )
  }
  if (filters.email) {
    query = query.where('email', 'like', `%${filters.email}%`)
  }
  if (filters.accountId) {
    query = query.where('account_id', '=', filters.accountId)
  }
  if (filters.isGuest !== undefined) {
    query = query.where('is_guest', '=', filters.isGuest ? 1 : 0)
  }
  if (filters.softwareLicenses) {
    const isNoLicenseSelected = filters.softwareLicenses.includes('no-license')
    const licenses = filters.softwareLicenses.filter(
      (key) => key !== 'no-license'
    )

    query = query.where((eb) => {
      const conditions = []
      if (isNoLicenseSelected) {
        conditions.push(eb('software_licenses', '=', '{}'))
      }

      if (licenses.length > 0) {
        const licensesConditions = licenses.map(
          (key) =>
            sql`json_extract(${eb.ref('software_licenses')}, ${`$.${key}`}) IS NOT NULL`
        )
        conditions.push(eb.or(licensesConditions))
      }

      return eb.or(conditions)
    })
  }
  if (filters.applications?.length) {
    query = query.where('software_id', 'in', filters.applications)
  }

  return query
}
